import React from 'react';
import styled from 'styled-components';

import PoweredByLinko from '../../../image/PoweredByLinko.png';

export default function PoweredByLinkoImage() {
  return (
    <Wrapper>
      <Image src={PoweredByLinko} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 16px 0;

  width: 202px;

  @media (min-height: 320px) {
    margin: 4px 0;

    width: 62px;
  }
  @media (min-height: 640px) {
    margin: 6px 0;

    width: 82px;
  }
  @media (min-height: 680px) {
    margin: 8px 0;

    width: 102px;
  }
  @media (min-height: 720px) {
    margin: 10px 0;

    width: 122px;
  }
  @media (min-height: 760px) {
    margin: 12px 0;

    width: 142px;
  }
  @media (min-height: 800px) {
    margin: 14px 0;

    width: 162px;
  }
  @media (min-height: 1000px) {
    margin: 16px 0;

    width: 182px;
  }
  @media (min-height: 1200px) {
    margin: 18px 0;

    width: 202px;
  }
`;

const Image = styled.img`
  width: 100%;
`;
